import React, { useState, useEffect, useContext } from "react";
import SupplierProductReadOnlyRow from "./SupplierProductReadOnlyRow";
import SupplierProductTableRow from "./SupplierProductTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function SupplierProductTable({ key, setProduct, partner, supplierCompanyId, resetMenu }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isCompanyProductLoading, setIsCompanyProductLoading] = useState(false);
    const [isPartnerProductLoading, setIsPartnerProductLoading] = useState(false);
    const [isSupplierDateLoading, setIsSupplierDateLoading] = useState(false);
    const [companyProductList, setCompanyProductList] = useState([]);
    const [partnerProducts, setPartnerProducts] = useState([]);
    const [supplierDates, setSupplierDates] = useState([]);
    const [count, setCount] = useState(key);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        partnershipKey: partner.partnershipKey,
        supplierCompanyId: supplierCompanyId,
        clientCompanyId: partner.clientCompanyId,
        companyProductKey: 0,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchCompanyProducts();
        fetchPartnerProducts();
        fetchSupplierDates();
    }, []);

    const handleClose = (event) => {
        setProduct(false);
        if (resetMenu) {
            resetMenu();
        }
    };

    function fetchCompanyProducts() {
        setError("");
        if (!supplierCompanyId || supplierCompanyId === 0) {
            return;
        }
        setIsCompanyProductLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false, companyId: supplierCompanyId }),
        };
        try {
            FetchUtil.fetchAPI("MGetCompanyProduct", "/Service/CompanyService/GetCompanyProduct", requestOptions, getCompanyProductsSuccess, getCompanyProductsFail);
        } catch (error) {
            setIsCompanyProductLoading(false);
            setError(error.message);
        }
    }

    function getCompanyProductsFail(redirect) {
        setIsCompanyProductLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getProdFailed"));
    }
    function getCompanyProductsSuccess(responseData) {
        let getCompanyProductResponse;
        if (responseData) {
            getCompanyProductResponse = responseData.getCompanyProductResponse;
            if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "0") {
                setCompanyProductList([...getCompanyProductResponse.products]);
            } else if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getCompanyProductResponse) {
                setError(t("error.error") + " " + getCompanyProductResponse.errorMessage);
            }
        }
        setIsCompanyProductLoading(false);
    }


    function fetchPartnerProducts() {
        setError("");
        if (!initialValues.supplierCompanyId || initialValues.supplierCompanyId === 0
            || !initialValues.clientCompanyId || initialValues.clientCompanyId === 0) {
            return;
        }
        resetCounter();
        setIsPartnerProductLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, supplierKey: initialValues.supplierCompanyId,
                buyerKey: initialValues.clientCompanyId, userCompanyId: userCompanyId,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerProducts", "/Service/CompanyService/GetPartnerProducts", requestOptions, retrievePartnerProductSuccess, retrievePartnerProductFail);
        } catch (error) {
            setIsPartnerProductLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerProductFail(redirect) {
        setIsPartnerProductLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetProdFailed"));
    }

    function retrievePartnerProductSuccess(responseData) {
        let getPartnerProductResponse;
        if (responseData) {
            getPartnerProductResponse = responseData.getPartnerProductResponse;
            if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "0") {
                setPartnerProducts(getPartnerProductResponse.products.slice())
            } else if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerProductResponse) {
                setError(t("error.error") + " " + getPartnerProductResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsPartnerProductLoading(false);
    }

    function fetchSupplierDates() {
        setError("");
        if (!initialValues.supplierCompanyId || initialValues.supplierCompanyId === 0
            || !initialValues.partnershipKey || initialValues.partnershipKey === 0
            || !initialValues.clientCompanyId || initialValues.clientCompanyId === 0) {
            return;
        }
        resetCounter();
        setSupplierDates([]);
        setIsSupplierDateLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false, supplierKey: initialValues.supplierCompanyId,
                partnershipKey: initialValues.partnershipKey, buyerKey: initialValues.clientCompanyId,
                userCompanyId: userCompanyId,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerDates", "/Service/CompanyService/GetPartnerDates", requestOptions, retrievePartnerDateSuccess, retrievePartnerDateFail);
        } catch (error) {
            setIsPartnerSurveyLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerDateFail(redirect) {
        setIsSupplierDateLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetDateFailed"));
    }

    function retrievePartnerDateSuccess(responseData) {
        let getPartnerDatesResponse;
        if (responseData) {
            getPartnerDatesResponse = responseData.getPartnerDatesResponse;
            if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "0") {
                setSupplierDates(getPartnerDatesResponse.supplierDates.slice())
            } else if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerDatesResponse) {
                setError(t("error.error") + " " + getPartnerDatesResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsSupplierDateLoading(false);
    }

    const handleDeleteClick = (event, partnerProductItem, completeCallback) => {
        event.preventDefault();
        deletePartnerProduct(partnerProductItem, completeCallback);
    };
    const deletePartnerProduct = (partnerProductItem, completeCallback) => {
        let action = 3;
        if (partnerProductItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            supplierCompanyId: formValues.supplierCompanyId,
            clientCompanyId: formValues.clientCompanyId,
            partnershipKey: formValues.partnershipKey,
            companyProductKey: partnerProductItem.companyProductKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeletePartnerProduct", "/Service/CompanyService/DeletePartnerProduct", requestOptions, deletePartnerProductSuccess, deletePartnerProductFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deletePartnerProductFail(redirect, completeCallback) {
        setError(t("error.prodEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deletePartnerProductSuccess(responseData, completeCallback) {
        let deletePartnerProductResponse;
        if (responseData) {
            deletePartnerProductResponse = responseData.deletePartnerProductResponse;
            if (deletePartnerProductResponse) {
                if (deletePartnerProductResponse.errorCode === "0") {
                    resetRowTable();
                    fetchPartnerProducts();
                } else {
                    setError(t("error.error") + " " +
                        deletePartnerProductResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.supplierCompanyId || formValues.supplierCompanyId === 0
            || !formValues.clientCompanyId || formValues.clientCompanyId === 0) {
            setError(t("error.prodEditFailed"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (partnerProducts.length > 0) {
                partnerProducts.map((partnerProductItem, index) => {
                    if (partnerProductItem.companyProductKey == setValues.companyProductKey) {
                        setError(t("error.prodDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                savePartnerProduct(action, setValues, completeCallback);
            }
        } else if (action === 2) {
            if (partnerProducts.length > 0) {
                partnerProducts.map((partnerProductItem, index) => {
                    if (partnerProductItem.partnershipKey === formValues.partnershipKey &&
                        partnerProductItem.companyProductKey === setValues.companyProductKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                savePartnerProduct(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        }
    };
    const savePartnerProduct = (action, setValues, completeCallback) => {
        let serverParams = {
            supplierCompanyId: formValues.supplierCompanyId,
            clientCompanyId: formValues.clientCompanyId,
            partnershipKey: formValues.partnershipKey,
            companyProductKey: setValues.companyProductKey,
            partnershipDateKeys: setValues.partnershipDateKeys,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdatePartnerProduct", "/Service/CompanyService/AddUpdatePartnerProduct", requestOptions, savePartnerProductSuccess, savePartnerProductFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function savePartnerProductFail(redirect, completeCallback) {
        setError(t("error.prodEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function savePartnerProductSuccess(responseData, completeCallback) {
        let addUpdatePartnerProductResponse;
        if (responseData) {
            addUpdatePartnerProductResponse = responseData.addUpdatePartnerProductResponse;
            if (addUpdatePartnerProductResponse) {
                if (addUpdatePartnerProductResponse.errorCode === "0") {
                    resetRowTable();
                    fetchPartnerProducts();
                } else {
                    setError(t("error.error") + " " +
                        addUpdatePartnerProductResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isCompanyProductLoading || isPartnerProductLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.productGrp")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.commoName")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.prodName")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.prodNum")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.description")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.dates.access")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "11vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <SupplierProductTableRow
                                            key={count}
                                            companyProductList={companyProductList}
                                            supplierDates={supplierDates}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((partnerProducts.length % 2) > 0) ? true : false} />
                                    }
                                    {(partnerProducts.length > 0) ? (
                                        partnerProducts.map((partnerProductItem, index) => (
                                            <SupplierProductReadOnlyRow
                                                key={count}
                                                t={t}
                                                supplierDates={supplierDates}
                                                partnerProductItem={partnerProductItem}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                add={add}
                                                setError={setError}
                                                handleSubmit={handleSubmit}
                                            />
                                        ))
                                    ) : (<></>)}
                                    {add && addRowBottom &&
                                        <SupplierProductTableRow
                                            key={count}
                                            companyProductList={companyProductList}
                                            supplierDates={supplierDates}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((partnerProducts.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(partnerProducts.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.productGrp")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.commoName")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.prodName")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.prodNum")}</th>
                                        <th className="list-th" style={{ maxWidth: "12vw" }}>{t("page.description")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.dates.access")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "11vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                            <div className="row">
                                <div className="col mt-3">
                                    {(error) ? (
                                        <div id="inerrorMessage1" className="errorblock">
                                            {error}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-comp-prod-close"
                                    id="edit-comp-prod-close"
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose(e)}
                                    style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={closeText}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}
export default SupplierProductTable;